// SVG-pad van een QR-code (golf 6a): één rechthoek per reeks donkere modules op een rij, met een
// stille rand van `margin` modules. Los van de component, zodat de e2e dezelfde QR-code uit de
// URL van de API kan narekenen en vergelijken met wat de pagina toont.

export interface QrModules {
  size: number;
  data: ArrayLike<number | boolean>;
}

export function qrPath(modules: QrModules, margin: number): string {
  const parts: string[] = [];
  const n = modules.size;
  for (let y = 0; y < n; y += 1) {
    let x = 0;
    while (x < n) {
      if (modules.data[y * n + x]) {
        let run = 1;
        while (x + run < n && modules.data[y * n + x + run]) run += 1;
        parts.push(`M${x + margin} ${y + margin}h${run}v1h-${run}z`);
        x += run;
      } else {
        x += 1;
      }
    }
  }
  return parts.join('');
}
